import type { Theme } from "@mui/material/styles";
import { makeStyles, createStyles } from "@mui/styles";

export const WalletOptionStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      // minHeight: "105px",
      alignSelf: "center",
      justifyContent: "flex-end",
      marginLeft: "0px",
      [theme.breakpoints.up("md")]: {
        padding: "0px",
        // minHeight: 0,
      },
      [theme.breakpoints.between("md", "lg")]: {
        padding: "0px",
        // padding: "25px 0px 10px 0px",
        // minHeight: 0,
      },
    },
    iconDescriptionContainer: {
      textDecoration: "none",
      color: "#000",
      display: "flex",
      [theme.breakpoints.down("sm")]: {
        marginBottom: "18px",
      },
    },
    cursor: {
      cursor: "pointer",
      [theme.breakpoints.down("sm")]: {
        padding: "0px",
        display: "none",
      },
    },
    description: {
      fontSize: "16px",
      fontWeight: theme.typography.fontWeightMedium,
      marginLeft: "7px",
      marginTop: "3px",
      [theme.breakpoints.down("sm")]: {
        fontSize: "14px",
        alignContent: "center",
        padding: "0 10px",
        height: "25px",
        margin: "0px",
        textAlign: "center",
        backgroundColor: theme.palette.primary.main,
        color: "#FFF",
        fontWeight: 600,
        borderRadius: "4px",
        cursor: "pointer",
        boxShadow: "0 4px 4px 0 #d8d8da",
      },
    },
    descriptionWithdrawal: {
      fontSize: "16px",
      fontWeight: theme.typography.fontWeightMedium,
      marginLeft: "7px",
      marginTop: "3px",
      [theme.breakpoints.down("sm")]: {
        fontSize: "14px",
        width: "80px",
        height: "25px",
        margin: "0px",
        textAlign: "center",
        background: "#D1D4D6",
        color: "#BDC2C5",
        fontWeight: 600,
        padding: "2px",
        borderRadius: "4px",
        cursor: "pointer",
      },
    },
    optionButtons: {
      marginLeft: "10px",
      height: 48,
      border: "1px solid #A3A3A3",
      textTransform: "none",
    },
    buttonText: {
      fontSize: "14px",
    },
    buttonContainer: {
      height: "33px",
      border: "1px solid #A3A3A3",
      color: theme.palette.text.secondary,
      textTransform: "none",
      borderRadius: "10px",
      fontSize: "14px",
      margin: "5px",
      padding: "8px",
    },
  }),
);
